import React from "react";
import { useTranslation } from "react-i18next";
import NewFormField from "../../../../../common/layout/form/NewFormField";
import { container, divider, fieldContainer} from "../../../../styles/fieldsContainer.styles";

const DepartmentsFields: React.FC = () => {
  const { t } = useTranslation("admin");
  return (
    <div className={container}>
      <div className={divider}>
        <div className={fieldContainer}>
          <NewFormField name="city" label={t("auth.formLabels.city") as string} />
        </div>
        <div className={fieldContainer}>
          <NewFormField name="postalCode" label={t("auth.formLabels.postalCode") as string} />
        </div>
      </div>
      <NewFormField name="street" label={t("auth.formLabels.street") as string} />
    </div>
  );
};

export default DepartmentsFields;